import React from "react";
import { Bot, Brain, Wrench, Menu, X, Clapperboard, Swords, ShieldCheck, GitBranch, Zap } from "lucide-react";

export const MAIN = [
  { id: "nexus", label: "Nexus", icon: Bot },
  { id: "ponytail", label: "Ponytail", icon: Brain },
  { id: "devbridge", label: "Dev Bridge", icon: GitBranch },
  { id: "enginev2", label: "Engine V2", icon: Zap },
  { id: "anne", label: "Miss Anne", icon: ShieldCheck },
  { id: "hercules", label: "Hercules 2.0", icon: Swords },
  { id: "clipsy", label: "Clipsy", icon: Clapperboard },
  { id: "tools", label: "A V Tools", icon: Wrench },
];

export const MoreSheet = ({ items, onPick, onClose }) => (
  <div className="fixed inset-0 z-[70] bg-black/60 backdrop-blur-sm flex items-end md:items-start md:justify-end" onClick={onClose} data-testid="more-sheet">
    <div className="nx-panel w-full md:w-80 md:mt-16 md:mr-4 rounded-t-3xl md:rounded-3xl p-4 pb-[calc(16px+env(safe-area-inset-bottom))] max-h-[75dvh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between mb-3">
        <p className="nx-orbitron text-sm tracking-[0.3em] text-[var(--nx-cyan)]">MORE</p>
        <button onClick={onClose} className="w-11 h-11 flex items-center justify-center text-cyan-100/70" data-testid="more-sheet-close"><X className="w-5 h-5" /></button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {items.map((it) => (
          <button key={it.key} onClick={() => onPick(it)} data-testid={`more-item-${it.key}`}
            className="nx-tap relative min-h-[64px] rounded-2xl border border-cyan-300/15 bg-white/[0.03] flex flex-col items-center justify-center gap-1 text-[11px] nx-mono tracking-wider text-cyan-100/80">
            <it.icon className="w-5 h-5 text-[var(--nx-cyan)]" />{it.label}
            {it.badge > 0 && <span className="absolute top-1 right-2 min-w-[18px] h-[18px] rounded-full bg-[var(--nx-magenta)] text-white text-[10px] flex items-center justify-center">{it.badge}</span>}
          </button>
        ))}
      </div>
    </div>
  </div>
);

const Item = ({ it, active, onClick, badge, mobile }) => (
  <button onClick={onClick} data-testid={`${mobile ? "bottom" : "top"}-nav-${it.id}`}
    className={`nx-tap relative min-h-[44px] flex items-center justify-center gap-2 transition-colors duration-200 ${mobile ? "flex-1 flex-col text-[10px] gap-0.5" : "px-4 rounded-full text-xs"} nx-mono tracking-widest font-bold ${active ? "text-[var(--nx-cyan)] nx-glow-text" + (mobile ? "" : " bg-[var(--nx-cyan)]/10 border border-[var(--nx-cyan)]/40") : "text-cyan-100/55 hover:text-cyan-50"}`}>
    <it.icon className={mobile ? "w-5 h-5" : "w-4 h-4"} />{it.label.toUpperCase()}
    {badge > 0 && <span className="absolute top-1 right-1/4 w-2 h-2 rounded-full bg-[var(--nx-magenta)]" />}
  </button>
);

export const MainNav = ({ section, onSection, onMore, moreBadge, right }) => {
  const more = { id: "more", label: "More", icon: Menu };
  return (
    <>
      <div className="hidden md:flex sticky top-0 z-40 h-14 items-center gap-2 px-4 nx-panel rounded-none border-x-0 border-t-0" data-testid="top-nav">
        <span className="nx-orbitron text-sm tracking-[0.3em] text-[var(--nx-cyan)] mr-4">A V NEXUS</span>
        {MAIN.map((it) => <Item key={it.id} it={it} active={section === it.id} onClick={() => onSection(it.id)} />)}
        <Item it={more} active={!MAIN.some((m) => m.id === section)} onClick={onMore} badge={moreBadge} />
        <div className="ml-auto">{right}</div>
      </div>
      <div className="md:hidden fixed bottom-0 inset-x-0 z-40 flex nx-panel rounded-none border-x-0 border-b-0 pb-[env(safe-area-inset-bottom)]" style={{ height: "var(--nav-h)" }} data-testid="bottom-nav">
        {MAIN.map((it) => <Item mobile key={it.id} it={it} active={section === it.id} onClick={() => onSection(it.id)} />)}
        <Item mobile it={more} active={!MAIN.some((m) => m.id === section)} onClick={onMore} badge={moreBadge} />
      </div>
    </>
  );
};
